import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { JournalTransaction } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormGeneral, FormCoaes } from './component/form';

const initialState = {
  data: null,
  general: null,
  items: null,
  isLoading: true,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateForm = useSelector((state) => state?.Form);
  const isLoading = useSelector(
    (state) => state?.Activity?.services['JournalTransaction.Show']
  );

   const [{ general, items, data }, setState] =
    React.useState(initialState);

  const $onLoad = async (e) => {
    const req = await Dispatch(JournalTransaction.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: req?.data,
      }));
    }
  };

  const $handleSubmit = async (e) => {
    const payload = {
      name: general?.name,
      items
    };

    const req = await Dispatch(JournalTransaction.$update(data?.id, payload));

    if (req?.message === 'success') {
      History?.push(`/accounting/transaction`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed col-lg-7">
      <Page.Header title="Perbaharui Transaction Journal" className="bg-light" />

      <Page.Body className="d-block row px-3">
        <FormGeneral
          data={data}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, general: e }))
          }
          isLoading={isLoading}
        />
        <FormCoaes
          data={data?.items}
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, items: e }))
          }
          isLoading={isLoading}
        />
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-0 pb-md-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/accounting/transaction`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
